export const planOptions = {
    free: [
        {
            id: 1,
            description: '3 pharma courses access'
        },
        {
            id: 2,
            description: 'Limited skill tree access'
        },
        {
            id: 3,
            description: 'Free course certificates'
        }
    ],
    premium: [
        {
            id: 1,
            description: '40+ pharma expert courses'
        },
        {
            id: 2,
            description: 'TÜV ISO-9001 certifications'
        },
        {
            id: 3,
            description: 'Monthly VIP career coaching'
        },
        {
            id: 4,
            description: 'Pharma resume builder'
        },
        {
            id: 5,
            description: 'Pharma cover letter builder'
        },
        {
            id: 6,
            description: 'Full skill tree access'
        },
        {
            id: 7,
            description: 'Personalized pharma career path'
        }
    ],

}